import { useState, useRef, useEffect } from 'react';
import __isEmpty from 'lodash/isEmpty';
import styles from './desplegable.module.scss';
import Icona from 'components/corporatiu/Icona';
import clsx from 'clsx';

export default function Desplegable({
    titol,
    children,
    tag = 'span',
    className,
    estil,
    tema,
    icona = 'mes_bold',
    iconaOpen = 'mes_bold',
    inLayout = false
}) {
    const contentRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [isOpen, children]);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const stylesIcona = clsx({
        [styles.icona]: true,
        [styles.open]: isOpen
    });

    const stylesBoto = clsx({
        [styles.boto]: true,
        [styles.open]: isOpen
    });

    const stylesContentDesplegable = clsx({
        [styles.contentDesplegable]: true,
        [styles.open]: isOpen
    });

    const styleDesplegable = clsx({
        [styles.desplegable]: true,
        [styles[estil]]: !__isEmpty(estil),
        [styles[tema]]: !__isEmpty(tema),
        [className]: !__isEmpty(className)
    });

    const Tag = tag;

    return (
        <div className={styleDesplegable}>
            <div className={styles.headerDesplegable}>
                <Tag className={styles.titol}>{titol}</Tag>
                <button
                    className={stylesBoto}
                    onClick={handleToggle}
                    aria-expanded={isOpen}
                    aria-label={isOpen ? 'Tancar pregunta' : 'Obrir pregunta'}
                >
                    <Icona icona={isOpen ? iconaOpen : icona} isBlanc={true} className={stylesIcona} inline={true} />
                </button>
            </div>
            <div
                ref={contentRef}
                className={stylesContentDesplegable}
                aria-hidden={!isOpen}
                style={{
                    height
                }}
            >
                {inLayout ? <div dangerouslySetInnerHTML={{ __html: children }} /> : children}
            </div>
        </div>
    );
}
